/*
 * Module for the IRS 945 Form job criteria page
 */
rs.module("content/jobs/criteria/irs945form",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, codeValues, refundAccountFieldsYear) {

            var criteria = $.js(jsSelectors.criteria);

            var taxYearSelect = criteria.js(jsSelectors.taxYearSelect);
            var completionMethodSelect = criteria.js(jsSelectors.completionMethodSelect);
            var addressChangeCheckBox = criteria.js(jsSelectors.addressChangeCheckBox);
            var backupWithholdingTextBox = criteria.js(jsSelectors.backupWithholdingTextBox);
            var depositsTextBox = criteria.js(jsSelectors.depositsTextBox);
            var overpaymentAppliedToSelect = criteria.js(jsSelectors.overpaymentAppliedToSelect);

            var refundAccountFieldsContainer = criteria.js(jsSelectors.refundAccountFieldsContainer);
            var routingNumberTextBox = refundAccountFieldsContainer.js(jsSelectors.routingNumberTextBox);
            var accountNumberTextBox = refundAccountFieldsContainer.js(jsSelectors.accountNumberTextBox);
            var accountTypeSelect = refundAccountFieldsContainer.js(jsSelectors.accountTypeSelect);

            var finalPaymentCheckBox = criteria.js(jsSelectors.finalPaymentCheckBox);
            var finalPaymentDateInput = criteria.js(jsSelectors.finalPaymentDateInput);

            // Get Select Helper for Select Lists where we're updating their options and properties
            var overpaymentAppliedToSelectHelper = selectHelper.getHelper(overpaymentAppliedToSelect);
            var accountTypeSelectHelper = selectHelper.getHelper(accountTypeSelect);

            taxYearSelect.on("change", toggleRefundAccountFields);
            overpaymentAppliedToSelect.on("change", toggleRefundAccountFields);

            // Register completionMethodSelect change event to hide/show appropriate fields
            completionMethodSelect.on("change", completionMethodSelectChanged);

            // Register finalPaymentDateInput change event to hide/show appropriate fields
            finalPaymentCheckBox.on("change", finalPaymentCheckBoxChanged);

            // Enable/disable fields based on completionMethodSelect changed
            function completionMethodSelectChanged() {
                var isManual = completionMethodSelect.val() === codeValues.completionMethodManual.toString();

                if (isManual) {
                    addressChangeCheckBox.setChecked(false);
                    addressChangeCheckBox.prop('disabled', true);
                    backupWithholdingTextBox.clearErrors().val('').prop('disabled', true);
                    depositsTextBox.clearErrors().val('').prop('disabled', true);
                    overpaymentAppliedToSelectHelper.setValue('').setDisabled(true);
                    finalPaymentCheckBox.setChecked(false);
                    finalPaymentCheckBox.prop('disabled', true);
                    finalPaymentDateInput.clearErrors().val('').prop('disabled', true);
                }
                else {
                    addressChangeCheckBox.prop('disabled', false);
                    backupWithholdingTextBox.prop('disabled', false);
                    depositsTextBox.prop('disabled', false);
                    overpaymentAppliedToSelectHelper.setDisabled(false);
                    finalPaymentCheckBox.prop('disabled', false);
                }

                toggleRefundAccountFields();
            }

            // Enable/disable finalPaymentDateInput based on finalPaymentCheckBox changed
            function finalPaymentCheckBoxChanged() {

                if (finalPaymentCheckBox.is(":checked")) {
                    finalPaymentDateInput.prop('disabled', false);
                }
                else {
                    finalPaymentDateInput.clearErrors().val('').prop('disabled', true);
                }
            }

            // Show/hide account info fields based on tax year and Refund selected
            function toggleRefundAccountFields() {
                let shouldShowRefundAccountFields =
                    taxYearSelect.val() >= refundAccountFieldsYear &&
                    overpaymentAppliedToSelect.val() == codeValues.overpaymentAppliedToRefund &&
                    completionMethodSelect.val() == codeValues.completionMethodSystem;

                visibility.setVisible(refundAccountFieldsContainer, shouldShowRefundAccountFields);

                if (!shouldShowRefundAccountFields) {
                    routingNumberTextBox.clearErrors().val('');
                    accountNumberTextBox.clearErrors().val('');

                    accountTypeSelect.clearErrors();
                    accountTypeSelectHelper.selectIndex(0);
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);